export const CREATE_CATEGORY = 'CREATE_CATEGORY'
export const GET_LIST_CATEGORY = 'GET_LIST_CATEGORY'
export const DETAIL_CATEGORY = 'DETAIL_CATEGORY'
export const PATCH_CATEGORY = 'PATCH_CATEGORY'
